import { AppModule } from '@/store/modules/app';
import { ClustersModule } from '@/store/modules/clusters';
import { ProfessionModule } from '@/store/modules/profession';

/**
 * Міксин для селекта кластерів у ProfessionsComponent.
 * Надає: clusterListWithCount, clusterSelectOptions, selectedClusterId, onClusterSelectChange.
 * Очікує в компоненті: translations, toLocaleLangString, allCount, loadProfessionItems().
 */
export default {
  computed: {
    clusterListWithCount(this: any): { id: number, name: string, count: number }[] {
      const portal = AppModule.settingPortal?.clusters || [];
      const counts = (AppModule.jobCountPortal?.clusters || []) as { id: number, count: number }[];
      return portal.map((el: any) => {
        const item = counts.find((x) => x.id === el.id);
        return {
          id: el.id,
          name: el.name,
          count: item?.count ?? 0,
        };
      });
    },

    clusterSelectOptions(this: any): { value: any, text: string, disabled?: boolean }[] {
      const list = this.clusterListWithCount;
      const placeholderOption = {
        value: null,
        text: 'Bitte wählen Sie ein Berufsfeld...',
        disabled: true,
      };
      const defaultOption = {
        value: 0,
        text: `${this.toLocaleLangString(this.allCount || 0)} ${this.allCount === 1 ? this.translations[13785] : this.translations[13774]}`,
      };
      const clusterOptions = list.map((c: any) => ({
        value: c.id,
        text: `${c.name} (${this.toLocaleLangString(c.count)})`,
      }));
      return [placeholderOption, ...clusterOptions];
    },

    selectedClusterId: {
      get(): number | null {
        const id = ClustersModule.jobClusterParams.cluster_id;
        return id == null ? null : Number(id);
      },
      set(value: number | string | null) {
        if (value == null || value === '') {
          ClustersModule.SetClusterParams({ obj: 'cluster_id', value: null });
          return;
        }
        const n = Number(value);
        ClustersModule.SetClusterParams({ obj: 'cluster_id', value: n === 0 ? null : n });
      },
    },
  },

  methods: {
    onClusterSelectChange(this: any, value: number | string | null) {
      if (value == null || value === '') return;
      const n = Number(value);
      if (n === 0) {
        AppModule.SetVisibleClusterJobs(false);
        ClustersModule.ResetClusterData();
        ClustersModule.SetProfessionTitle('');
        ClustersModule.SetClusterParams({ obj: 'cluster_id', value: null });
        ProfessionModule.SetFilter({ obj: 'cluster_id', value: 0 });
        ProfessionModule.SetSearchTags({ tag: 'clusterTag', value: null });
        this.loadProfessionItems();
        return;
      }
      AppModule.SetVisibleClusterJobs(true);
      ClustersModule.SetClusterParams({ obj: 'cluster_id', value: n });
      ProfessionModule.SetFilter({ obj: 'cluster_id', value: n });
      ProfessionModule.SetSearchTags({ tag: 'clusterTag', value: n });
      const cluster = this.clusterListWithCount.find((c: any) => c.id === n);
      if (cluster) {
        ClustersModule.SetProfessionTitle(cluster.name);
      }
      this.loadProfessionItems();
    },
  },
};
